import React from "react";
import { useState } from "react";
import { questions } from "./questions";
import FaqItem from "../includes/faqQuestion";
    
const FAQ = () => {
    const [isActive, setActive] = useState("0");

    const toggleQuestion = (id) => {
        if (isActive === id) {
            return setActive("0");
           }
           setActive(id);
    };

    return (
        <div className="w-full flex lg:flex-row flex-col items-start justify-between container mx-auto lg:p-20 md:px-12 py-20 6 px-4 md:gap-16 gap-8">
            <h2 className="text-left max-w-xs lg:text-4xl md:text-3xl text-2xl font-normal pointer-events-none text-blue10">Still have questions? We have answers.</h2>
            <div className="w-full flex flex-col gap-x-32 gap-y-8 text-base text-left">
                {questions.map((faq) => (
                    <FaqItem key={faq.id} faq={faq} onToggle={() => toggleQuestion(faq.id)} active={isActive === faq.id}/>
                ))}
            </div>
        </div>
    )
}

export default FAQ;